import { all } from '../data/all';

function SmallestPopulation() {


    let countryData = [];
    
    all.forEach(thisCountry => {
        countryData = [...countryData, {name : thisCountry.name.common, population : thisCountry.population}];
    })

    // https://stackoverflow.com/questions/1969145/sorting-javascript-array-with-chrome
    // Pedro S Cord's answer, modified by Mario Petrovic
    // "the right way", modified here
    let sortedData = countryData.sort(function( a , b ){
        let result = a.population === b.population ? 0 : b.population > a.population ? -1 : 1;
        if(result === 0)
        {
          // implement a tight break evaluation
        }
        return result ;
       });
       
    return(
        <code>
            { JSON.stringify(sortedData) }
        </code>
    )
}

export default SmallestPopulation;